import { motion, useScroll } from "framer-motion";

/**
 * Two thin gold rails that fill as you scroll the page.
 * - Left rail: anchored to bottom, grows upward as scroll progresses.
 * - Right rail: anchored to top, grows downward.
 * Mounted once in PublicLayout so it appears on every public page.
 */
export default function ScrollRails() {
  const { scrollYProgress } = useScroll();
  return (
    <>
      <motion.div
        data-testid="scroll-rail-left"
        aria-hidden="true"
        className="fixed left-0 bottom-0 w-px h-screen bg-[#C9A050] origin-bottom z-[55] pointer-events-none"
        style={{ scaleY: scrollYProgress }}
      />
      <motion.div
        data-testid="scroll-rail-right"
        aria-hidden="true"
        className="fixed right-0 top-0 w-px h-screen bg-[#C9A050] origin-top z-[55] pointer-events-none"
        style={{ scaleY: scrollYProgress }}
      />
    </>
  );
}
